import agent_attorney_helpfultip_modal from "./agent_attorney_helpfultip_modal";
import agent_attorney_individ_helpfultip_modal from "./agent_attorney_individs_helpfultip_modal";
import employer_helpfultip_modal from "./employer_helpfultip_modal";
import employer_pocs_helpfultip_modal from "./employer_pocs_helpfultip_modal";
import foreign_labor_helpfultip_modal from "./foreign_labor_helpfultip_modal";
import crop_helpfultip_modal from "./crop_helpfultip_modal";
import agriculture_helpfultip_modal from "./agriculture_helpfultip_modal";
import worker_housing_helpfultip_modal from "./worker_housing_helpfultip_modal";
import material_terms_helpfultip_modal from "./material_terms_helpfultip_modal";
import foreign_worker_helpfultip_modal from "./foreign_worker_helpfultip_modal";
import foreign_worker_group_helpfultip_modal from "./foreign_worker_group_helpfultip_modal";


const HelpfulTipsUIResolver = (tableName) => {
  const profileUISchemaList = {
    "agent-attorney": agent_attorney_helpfultip_modal,
    "agent-attorney-individs": agent_attorney_individ_helpfultip_modal,
    employer: employer_helpfultip_modal,
    "employer-pocs": employer_pocs_helpfultip_modal,
    "foreign-labor": foreign_labor_helpfultip_modal,
    crop: crop_helpfultip_modal,
    "worker-housing": worker_housing_helpfultip_modal,
    agriculture: agriculture_helpfultip_modal,
    "material-terms": material_terms_helpfultip_modal,
    "foreign-worker": foreign_worker_helpfultip_modal,
    "foreign-worker-group": foreign_worker_group_helpfultip_modal,
  };
  return profileUISchemaList[tableName] || agent_attorney_helpfultip_modal;
};

export default HelpfulTipsUIResolver;
